import { createApiInstance } from "./apiClient";
import {getCookie} from "../utils/helpers";

const url = process.env.REACT_APP_ORDER_API_URL;

export const postEventResponse = async (eventId, eventResponse) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/form/`, retry: true });

		const body = {
			eventId,
			email: eventResponse.email,
			response: JSON.stringify(eventResponse),
		};

		return await instance
			.post(`event`, body)
			.then((response) => {
				if (response.status === 204)
					return {
						error: false,
						success: true,
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response && error.response.status === 409) {
					return {
						error: true,
						success: false,
						isDuplicate: true,
					};
				}
				else if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};
